export default "__VITE_ASSET__BZ2V0XUe__"